<div
  class="row form-group"
  [hidden]="state.hidden"
  [ngClass]="{
    'has-feedback': showValidation || isFormSubmitted,
    'ziro-forms-error': (showValidation || isFormSubmitted) && validationState === ValStates.INVALID,
    'ziro-forms-warning': validationState === ValStates.WARNING,
  }"
>
  <div class="col-12">
    <div class="d-flex gap-1">
      <select
        class="form-select"
        [(ngModel)]="selectedHour"
        (ngModelChange)="onSelectionChange()"
        [disabled]="state.disabled"
        data-automation="ziro-time-hour"
      >
        @for (hour of hours; track hour) {
          <option [value]="hour">{{ hour }}</option>
        }
      </select>

      <select
        class="form-select"
        [(ngModel)]="selectedMinute"
        (ngModelChange)="onSelectionChange()"
        [disabled]="state.disabled"
        data-automation="ziro-time-minute"
      >
        @for (minute of minuteOptions(); track minute) {
          <option [value]="minute">{{ minute }}</option>
        }
      </select>

      <select
        class="form-select"
        [(ngModel)]="selectedPeriod"
        (ngModelChange)="onSelectionChange()"
        [disabled]="state.disabled"
        data-automation="ziro-time-period"
      >
        @for (period of periods; track period) {
          <option [value]="period">{{ period }}</option>
        }
      </select>
    </div>

    @if ((showValidation || isFormSubmitted) && !!validationMessage?.content) {
      <div
        class="ziro-forms-validation-message"
        data-automation="ziro-forms-validation-message"
        [innerHTML]="validationMessage?.content | escapeHtml: validationMessage?.params"
      ></div>
    }
  </div>
</div>
